import { Col, Form, Row, Modal, Button } from 'react-bootstrap';

const SolicitacaoMotoboy = props => {
  return (
    <>
      <Row>
        <Col sm={4}>
          <Form.Group controlId="motoboyData" className="mt-4">
            <Form.Label>*Data do transporte:</Form.Label>
            <Form.Control
              autoComplete="new-off"
              required
              type="date"
              name="motoboyData"
              onChange={e => props.handleSolicitacaoMotoboy(e)}
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group controlId="motoboyHora" className="mt-4">
            <Form.Label>*Hora do transporte:</Form.Label>
            <Form.Control
              autoComplete="new-off"
              required
              type="time"
              min="09:00"
              max="16:00"
              name="motoboyHora"
              onChange={e => props.handleSolicitacaoMotoboy(e)}
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group controlId="motoboyTempo" className="mt-4">
            <Form.Label>*Tempo estimado:</Form.Label>
            <Form.Select
              className="border border-secondary"
              required
              name="motoboyTempo"
              onChange={e => props.handleSolicitacaoMotoboy(e)}
              value={props.motoboyTempo}
            >
              <option value="" disabled>Selecione o tempo</option>
              {['1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h'].map(item => (
                <option key={item} value={item}>{item}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <Form.Group controlId="motoboyPassageiro" className="mt-4">
            <Form.Label>*Nome do passageiro:</Form.Label>
            <Form.Control
              autoComplete="new-off"
              required
              type="text"
              name="motoboyPassageiro"
              onChange={e => props.handleSolicitacaoMotoboy(e)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group controlId="motoboyTelefone" className="mt-4">
            <Form.Label>*Telefone do passageiro:</Form.Label>
            <Form.Control
              autoComplete="new-off"
              required
              type="text"
              name="motoboyTelefone"
              onChange={e => props.handleSolicitacaoMotoboy(e)}
              placeholder="(21) 99999-9999"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Form.Group controlId="motoboySaida" className="mt-4">
            <Form.Label>*Endereço da saída:</Form.Label>
            <Form.Control
              autoComplete="new-off"
              required
              type="text"
              name="motoboySaida"
              onChange={e => props.handleSolicitacaoMotoboy(e)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group controlId="motoboyDestino" className="mt-4">
            <Form.Label>*Endereço do destino:</Form.Label>
            <Form.Control
              autoComplete="new-off"
              required
              type="text"
              name="motoboyDestino"
              onChange={e => props.handleSolicitacaoMotoboy(e)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Modal show={props.showModal} onHide={props.handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.veiculoError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SolicitacaoMotoboy;
